module.exports = __webpack_public_path__ + "img/1.a978e392.png";